import { TableBody as TBody } from "@mui/material";
import { useContext } from "react";
import { RedirectType } from "src/types/apps";

import Context from "../context";
import RowAddRedirect from "./RowRedirect/RowAddRedirect";
import RowAddRedirectForm from "./RowRedirect/RowAddRedirectForm";
import RowRedirect from "./RowRedirect/RowRedirect";

// ----------------------------------------------------------------------

type Props = {
	data: RedirectType[];
	reset: () => void;
};

export default function TableBody({ data, reset }: Props) {
	const { state } = useContext(Context);

	return (
		<TBody>
			{data.map((row, index) => (
				<RowRedirect {...row} key={index} />
			))}
			{state.showCreateRow && <RowAddRedirectForm reset={reset} />}
			<RowAddRedirect numberRedirects={data.length} />
		</TBody>
	);
}
